import React from 'react';
import { GamesBreadcrumb } from './index';
import { PlayGameLink } from './index';

export default function ImpulseTraderPage() {
  return (
    <div className="mx-auto rounded-xl bg-white p-4 shadow dark:bg-slate-900/80">
      <GamesBreadcrumb game="Impulse Trader" />
      <h1 className="mb-4 text-3xl font-bold text-slate-900 dark:text-slate-100">Impulse Trader</h1>
      <img
        src="/thumbnails/ImpulseTrader.png"
        alt="Impulse Trader game screenshot"
        className="mx-auto mb-4 w-full max-w-md rounded-lg bg-white shadow dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">About Impulse Trader</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Impulse Trader is a fast-paced micro-trading game where items flash across the screen with prices that rise and fall every second. Buy at the right moment, sell when the swing turns in your favour, and try to outscore everyone else before the timer runs out.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc space-y-1 pl-6 text-gray-700 dark:text-gray-300">
          <li>Watch the current item and its price as it shifts each second.</li>
          <li>Tap Buy to add it to your inventory, Sell to cash out while it is high, or Ignore to keep the pace going.</li>
          <li>Market events can cause temporary boosts or crashes that turn a simple trade into a big swing.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Why it’s fun</h2>
        <p className="text-gray-700 dark:text-gray-300">
          The game is all about quick reactions and reading momentum. It is easy to start, but the price swings and events create plenty of tense “should I cash out now?” moments.
        </p>
      </section>
      <section>
        <h2 className="mb-2 text-xl font-semibold text-slate-900 dark:text-slate-100">Play Impulse Trader</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Jump into a live room and see who can turn chaos into the biggest profit. The game is free to play with friends right here.
        </p>
        <PlayGameLink game="ImpulseTrader" gameTitle="Impulse Trader" />
      </section>
    </div>
  );
}
